/* Official Tabby promotion. Kaching's selected total is the displayed amount. */
(function () {
  var host = document.querySelector('[data-kp-tabby]');
  if (!host) return;
  var latest = null, rendered = null, ready = false;
  function amount() {
    var selected = document.querySelector('.kaching-bundles__bar--selected .kaching-bundles__bar-price');
    var value = selected ? Number(selected.textContent.replace(/[^\d.,]/g, '').replace(/,/g, '')) : Number(host.dataset.price);
    return Number.isFinite(value) && value > 0 ? value.toFixed(2) : null;
  }
  function render() {
    latest = amount();
    if (!ready || !latest || latest === rendered || !window.TabbyPromo) return;
    var old = host.querySelector('#TabbyPromo');
    var fresh = document.createElement('div');
    fresh.id = 'TabbyPromo';
    old.replaceWith(fresh);
    try {
      new window.TabbyPromo({selector:'#TabbyPromo', currency:host.dataset.currency,
        price:latest, lang:host.dataset.lang, source:'product',
        publicKey:host.dataset.publicKey, merchantCode:'default'});
      rendered = latest;
    } catch (error) { /* Keep the checkout availability message if the SDK fails. */ }
  }
  document.addEventListener('kp:offer-change', render);
  function loadPromotion() {
    var script = document.createElement('script');
    script.src = 'https://checkout.tabby.ai/tabby-promo.js';
    script.async = true;
    script.onload = function () { ready = true; render(); };
    document.head.appendChild(script);
  }
  /* On mobile the gallery comes first. Load the SDK as the buying area approaches. */
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
      observer.disconnect();
      loadPromotion();
    }, {rootMargin:'200px 0px'});
    observer.observe(host);
  } else {
    loadPromotion();
  }
})();
